import React from "react";
import Notifications, { notify } from "react-notify-toast";
import Loading from "./Loading";
// import WifiSSH from "./WifiSSH";
import BlockCode from "./BlockCode";
import "./App.css";
import UUID from "./uuid";

export default class BluetoothConnect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supportBluetooth: Boolean(window.navigator.bluetooth),
      isConnected: false,
      serverId: "",
      ssid: "",
      password: "",
      key: "pibox",
      wifiLock: false,
      characteristicsList: [],
      infoList: [],
      commandList: [],
      isBlockCoding: false,
      commandOutput: "",
      commandOutputShouldRefresh: false,
      loading: false,
      charLength: -1,
      customInfoCount: 0,
      customCommandCount: 0,
      wifiReset: false,
      isAndroid:
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1,
      isIphone:
        navigator.userAgent.indexOf("iPhone") > -1 ||
        navigator.userAgent.indexOf("iphone") > -1,
      wifiConnected: false,
      wifiDirectSSID: true,
      wifiEnt: false,
      entId: "",
    };
    for (let i in UUID) {
      UUID[i] = UUID[i].toLowerCase();
    }
  }

  componentDidMount() {}

  connectDevice = () => {
    navigator.bluetooth
      .requestDevice({
        filters: [
          {
            services: [UUID.SERVICE_ID],
          },
        ],
      })
      .then((device) => {
        //GO loading screen
        this.setState({ loading: true });
        return device.gatt.connect();
      })
      .then((server) => {
        this.setState({ serverId: server.device.id });
        return server.getPrimaryService(UUID.SERVICE_ID);
      })
      .then((service) => {
        if (this.state.isIphone) {
          // iOS webBLE does not support getCharacteristics()
          console.log("ios webBLE");
          return this.webBleConnect(service);
        } else {
          return service.getCharacteristics();
        }
      })
      .then(async (characteristics) => {
        console.log("Connected!");
        let characteristicsList = characteristics;
        this.setState({ isConnected: true });
        let infoList = [
          {
            preset: true,
            uuid: "",
            label: "Device ID",
            value: this.state.serverId,
          },
          {
            preset: true,
            uuid: UUID.DEVICE_MODEL,
            label: "Model",
            value: " ",
          },
          {
            preset: true,
            uuid: UUID.WIFI_NAME,
            label: "Wifi",
            value: "...",
          },
          {
            preset: true,
            uuid: UUID.IP_ADDRESS,
            label: "IP Address",
            value: "",
          },
        ];

        await this.subscribeCharacteristic(
          UUID.WIFI_NAME,
          infoList,
          characteristicsList
        );
        await this.subscribeCharacteristic(
          UUID.IP_ADDRESS,
          infoList,
          characteristicsList
        );
        await this.readInfoCharacteristic(
          UUID.DEVICE_MODEL,
          infoList,
          characteristicsList
        );
        await this.subscribeCharacteristic(
          UUID.NOTIFY_MESSAGE,
          infoList,
          characteristicsList
        );
        await this.subscribeCharacteristic(
          UUID.CUSTOM_COMMAND_NOTIFY,
          infoList,
          characteristicsList
        );

        characteristicsList
          .filter((i) => i.uuid.indexOf(UUID.CUSTOM_INFO_LABEL) >= 0)
          .map((item) =>
            infoList.push({
              uuid: item.uuid.replace(UUID.CUSTOM_INFO_LABEL, UUID.CUSTOM_INFO),
              uuid_label: item.uuid,
              label: "-",
              value: "",
            })
          );
        for (let i = 0; i < infoList.length; i++) {
          if (infoList[i].preset) continue;
          await this.readInfoCharacteristic(
            infoList[i].uuid_label,
            infoList,
            characteristicsList
          );
          await this.subscribeCharacteristic(
            infoList[i].uuid,
            infoList,
            characteristicsList
          );
        }
        let tempCharList = [];
        characteristicsList
          .filter((i) => i.uuid.indexOf(UUID.CUSTOM_COMMAND_LABEL) >= 0)
          .map((item) =>
            tempCharList.push({
              uuid: item.uuid,
              label: "...",
            })
          );
        let commandList = tempCharList;
        for (let i = 0; i < commandList.length; i++) {
          await this.readCommandLabel(
            commandList[i].uuid,
            commandList,
            characteristicsList
          );
        }
        this.setState({
          characteristicsList: characteristicsList,
          infoList: infoList,
          commandList: commandList,
        });
        //console.log(commandList);
        // 0: {uuid: "00000000-0000-0000-0000-fd2bcccc0001", label: "shutdown"}
        // 1: {uuid: "00000000-0000-0000-0000-fd2bcccc0002", label: "reboot"}
        // 2: {uuid: "00000000-0000-0000-0000-fd2bcccc0003", label: "start"}
        // 3: {uuid: "00000000-0000-0000-0000-fd2bcccc0004", label: "stop"}
        // 4: {uuid: "00000000-0000-0000-0000-fd2bcccc0005", label: "upload"}
        // 5: {uuid: "00000000-0000-0000-0000-fd2bcccc0006", label: "camStart"}
        // 6: {uuid: "00000000-0000-0000-0000-fd2bcccc0007", label: "wifiConnect"}

        // loading close
        this.setState({ loading: false });
      })
      .catch(console.log);
  };

  readCommandLabel = (uuid, commandList, characteristicsList) => {
    //console.log("readCommandLabel");
    return new Promise((resolve) => {
      this.getCharacteristicInit(uuid, characteristicsList)
        .readValue()
        .then((i) => i.buffer)
        .then(this.ab2str)
        .then((label) => {
          let tempCMDList = commandList;
          tempCMDList.find((i) => i.uuid === uuid).label = label;
          this.setState({ commandList: tempCMDList }, resolve());
        });
    });
  };

  readInfoCharacteristic = (uuid, infoList, characteristicsList) => {
    //console.log("readInfoCharacteristic");
    return new Promise((resolve) => {
      this.getCharacteristicInit(uuid, characteristicsList)
        .readValue()
        .then((i) => i.buffer)
        .then(this.ab2str)
        .then((value) => {
          const tempInfoList = infoList;
          if (tempInfoList.find((i) => i.uuid === uuid)) {
            tempInfoList.find((i) => i.uuid === uuid).value = value;
          }
          if (tempInfoList.find((i) => i.uuid_label === uuid)) {
            tempInfoList.find((i) => i.uuid_label === uuid).label = value;
          }
          if (tempInfoList !== this.state.infoList)
            this.setState({ infoList: tempInfoList }, resolve());
          else resolve();
        });
    });
  };

  subscribeCharacteristic = (uuid, infoList, characteristicsList) => {
    //console.log("subscribeCharacteristic");
    return new Promise(async (resolve) => {
      this.getCharacteristicInit(uuid, characteristicsList).addEventListener(
        "characteristicvaluechanged",
        (event) => {
          if (event.target.uuid === UUID.NOTIFY_MESSAGE) {
            let msg = this.ab2str(event.target.value.buffer);
            notify.show(msg, "custom", 3000, "teal");
          } else if (event.target.uuid === UUID.CUSTOM_COMMAND_NOTIFY) {
            let msg = this.ab2str(event.target.value.buffer);
            if (this.state.commandOutputShouldRefresh) {
              this.setState(
                { commandOutputShouldRefresh: false, commandOutput: "" },
                () => {
                  let output = this.state.commandOutput + msg;
                  if (output.endsWith("&#&")) {
                    output = output.replace("&#&", "");
                    this.setState({ commandOutputShouldRefresh: true });
                  }
                  this.setState({ commandOutput: output });
                }
              );
            } else {
              let output = this.state.commandOutput + msg;
              if (output.endsWith("&#&")) {
                output = output.replace("&#&", "");
                this.setState({ commandOutputShouldRefresh: true });
              }
              this.setState({ commandOutput: output });
            }
          } else {
            let value = this.ab2str(event.target.value.buffer);
            let tempInfoList = infoList;
            if (tempInfoList.find((i) => i.uuid === uuid)) {
              tempInfoList.find((i) => i.uuid === uuid).value = value;
            }
            if (tempInfoList.find((i) => i.uuid_label === uuid)) {
              tempInfoList.find((i) => i.uuid_label === uuid).label = value;
            }
            this.setState({ infoList: tempInfoList });
            //console.log(tempInfoList.find((i) => i.label === "IP Address"));
          }
        }
      );
      await this.getCharacteristicInit(
        uuid,
        characteristicsList
      ).startNotifications();
      resolve();
    });
  };

  webBleConnect = (service) => {
    return new Promise(async (resolve) => {
      await service
        .getCharacteristic(UUID.PREFIX + UUID.CUSTOM_INFO_COUNT)
        .then((characteristic) => characteristic.readValue())
        .then((i) => i.buffer)
        .then(this.ab2str)
        .then(parseInt)
        .then((value) => {
          console.log("custom-info-count " + value);
          this.setState({ customInfoCount: value });
        });
      await service
        .getCharacteristic(UUID.PREFIX + UUID.CUSTOM_COMMAND_COUNT)
        .then((characteristic) => characteristic.readValue())
        .then((i) => i.buffer)
        .then(this.ab2str)
        .then(parseInt)
        .then((value) => {
          console.log("custom-command-count " + value);
          this.setState({ customCommandCount: value }, () => {
            let customInfoList = [];
            for (let index = 0; index < this.state.customInfoCount; index++) {
              let ending = (index + 1).toString(16);
              ending = "0".repeat(4 - ending.length) + ending;
              customInfoList.push(UUID.PREFIX + UUID.CUSTOM_INFO + ending);
              customInfoList.push(
                UUID.PREFIX + UUID.CUSTOM_INFO_LABEL + ending
              );
            }
            let customCommandList = [];
            for (
              let index = 0;
              index < this.state.customCommandCount;
              index++
            ) {
              let ending = (index + 1).toString(16);
              ending = "0".repeat(4 - ending.length) + ending;
              customCommandList.push(
                UUID.PREFIX + UUID.CUSTOM_COMMAND_LABEL + ending
              );
            }
            resolve(
              Promise.all([
                service.getCharacteristic(UUID.SERVICE_NAME),
                service.getCharacteristic(UUID.DEVICE_MODEL),
                service.getCharacteristic(UUID.WIFI_NAME),
                service.getCharacteristic(UUID.IP_ADDRESS),
                service.getCharacteristic(UUID.NOTIFY_MESSAGE),
                service.getCharacteristic(UUID.INPUT_SEP),
                service.getCharacteristic(UUID.CUSTOM_COMMAND_INPUT),
                service.getCharacteristic(UUID.CUSTOM_COMMAND_NOTIFY),
                ...customInfoList.map((i) => service.getCharacteristic(i)),
                ...customCommandList.map((i) => service.getCharacteristic(i)),
              ])
            );
          });
        });
    });
  };
  ab2str = (buf) => {
    return String.fromCharCode.apply(null, new Uint8Array(buf));
  };

  getCharacteristic = (uuid) => {
    return this.state.characteristicsList.find((i) => i.uuid === uuid);
  };

  getCharacteristicInit = (uuid, characteristicsList) => {
    return characteristicsList.find((i) => i.uuid === uuid);
  };

  inputWifi = () => {
    if (this.state.wifiEnt) {
      this.setState(
        {
          key: this.state.key.trim().replace(/\|/g, "*"),
          ssid: this.state.ssid.trim().replace(/\|/g, "*"),
          entId: this.state.entId.trim().replace(/\|/g, "*"),
          password: this.state.password.trim().replace(/\|/g, "*"),
        },
        () => {
          let errMsg;
          if (this.state.ssid === "") {
            errMsg = "SSID cannot be empty.";
          }
          if (this.state.password === "") {
            errMsg = "Password cannot be empty.";
          }
          if (errMsg) {
            notify.show(errMsg, "custom", 3000, "teal");
            return;
          }
          this.setState({ wifiLock: true }, () =>
            setTimeout(() => {
              // this.sendCommand(
              //   this.state.commandList.find((c) => c.label === "wifiConnect")
              //     .uuid
              // );
              setTimeout(() => {
                this.setState({ wifiLock: false, wifiReset: false });
              }, 30000);
            }, 5000)
          );

          let sendArray = this.str2abs(
            `${this.state.key}%&%${this.state.ssid}%&%${this.state.password}%&%${this.state.entId}&#&`
          );
          this.sendSeparately(sendArray, UUID.INPUT_SEP);
        }
      );
    } else {
      this.setState(
        {
          key: this.state.key.trim().replace(/\|/g, "*"),
          ssid: this.state.ssid.trim().replace(/\|/g, "*"),
          password: this.state.password.trim().replace(/\|/g, "*"),
        },
        () => {
          let errMsg;
          if (this.state.ssid === "") {
            errMsg = "SSID cannot be empty.";
          }
          if (this.state.password === "") {
            // 비밀번호 없는 와이파이에 연결하기 위해 제거
            // errMsg = "Password cannot be empty.";
          }
          if (errMsg) {
            notify.show(errMsg, "custom", 3000, "teal");
            return;
          }
          this.setState({ wifiLock: true }, () =>
            setTimeout(() => {
              this.sendCommand(
                this.state.commandList.find((c) => c.label === "wifiConnect")
                  .uuid
              );
              setTimeout(() => {
                this.setState({ wifiLock: false, wifiReset: false });
              }, 30000);
            }, 5000)
          );

          let sendArray = this.str2abs(
            `${this.state.key}%&%${this.state.ssid}%&%${this.state.password}&#&`
          );
          this.sendSeparately(sendArray, UUID.INPUT_SEP);
        }
      );
    }
  };
  sendCommand = (uuid) => {
    let sendArray = this.str2abs(`${this.state.key}%&%${uuid.slice(-4)}&#&`);
    this.sendSeparately(sendArray, UUID.CUSTOM_COMMAND_INPUT);
  };
  sendSeparately = async (array, uuid) => {
    for (const i in array) {
      await this.getCharacteristic(uuid).writeValue(array[i]);
      await this.wait(0.4);
    }
  };
  wait = async (sec) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, 1000 * sec);
    });
  };

  waitCamera = async () => {
    let chk = true;
    if (
      this.state.infoList.find((i) => i.label === "IP Address") !== undefined &&
      this.state.infoList.find((i) => i.label === "IP Address").value !== ""
    ) {
      while (chk) {
        try {
          const resp = await fetchTimeout(
            "http://" +
              this.state.infoList.find((i) => i.label === "IP Address").value +
              ":8000/index.html",
            {},
            1000
          );

          if (!resp.ok) {
            await this.wait(0.5);
          } else {
            chk = false;
            return true;
          }
        } catch (error) {
          await this.wait(0.5);
        }
      }
    } else {
      alert("와이파이가 연결되어있지 않습니다.");
      return false;
    }
  };
  str2abs = (str) => {
    let val = "";
    for (let i = 0; i < str.length; i++) {
      if (val === "") {
        val = str.charCodeAt(i).toString(16);
      } else {
        val += "," + str.charCodeAt(i).toString(16);
      }
    }
    let valArray = val.split(",");
    let bufferArray = [];
    while (valArray.length > 0) {
      let value = valArray.splice(0, 20).join(",");
      bufferArray.push(
        new Uint8Array(
          value.match(/[\da-f]{2}/gi).map(function (h) {
            return parseInt(h, 16);
          })
        ).buffer
      );
    }
    return bufferArray;
  };

  setIsBlockCodingToFalse = () => {
    this.setState({ isBlockCoding: false });
    this.sendCommand(
      this.state.commandList.find((c) => c.label === "stop").uuid
    );
  };

  setLoadingToTrue = () => {
    this.setState({ loading: true });
  };

  setLoadingToFalse = () => {
    this.setState({ loading: false });
  };

  render() {
    return (
      <div className="BluetoothConnect">
        <div id="app">
          <Notifications />
          {this.state.loading ? <Loading /> : null}
          <img alt="logo" src="img/logo.svg" className="logo"></img>
          <div className="panel-container">
            {!this.state.supportBluetooth ? (
              <div className="connect-panel panel">
                <div className="panel-title">
                  장치에서 블루투스를 찾을 수 없습니다.
                </div>
                <p>
                  블루투스를 지원하는 브라우저(크롬 권장)를 사용하시고,
                  블루투스를 사용할 수 있는 지확인해주세요. 자세한 내용은{" "}
                  <a
                    href="https://github.com/WebBluetoothCG/web-bluetooth/blob/master/implementation-status.md"
                    target="_brank"
                  >
                    이 페이지
                  </a>{" "}
                  를 참고해주세요.
                </p>
              </div>
            ) : null}
            {!this.state.isConnected && this.state.supportBluetooth ? (
              <div className="connect-panel panel">
                <img
                  alt="Icon-arrow_back"
                  src="img/icon_arrow_back.svg"
                  className="Icon-arrow_back"
                ></img>
                <div className="character-button">
                  <img
                    alt="character"
                    src="img/character.svg"
                    className="character"
                  ></img>
                  <div className="Look-it-up">Bluetooth 설정</div>
                  <div className="PLAi-Bluetooth-">
                    에이스플레이를 움직일 Bluetooth를 찾아볼까요?
                  </div>
                  <div onClick={this.connectDevice}>
                    <img
                      alt="bluetooth_button"
                      src="img/bluetooth_button.svg"
                      className="bluetooth_button"
                    ></img>
                  </div>
                </div>
              </div>
            ) : null}
            {this.state.isConnected && false ? (
              <div className="info-panel panel">
                <div className="panel-title">기기 정보</div>
                {this.state.infoList.map((item) => {
                  if (
                    item.label === "Wifi" ||
                    item.label === "IP Address" ||
                    item.label === "CPU Temp" ||
                    item.label === "CPU Load"
                  ) {
                    return (
                      <div key={item.uuid} className="info-group">
                        <div className="label">{item.label}</div>
                        <div className="value">{item.value}</div>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            ) : null}
            {(this.state.isConnected &&
              (this.state.infoList.find((i) => i.label === "IP Address") ===
                undefined ||
                this.state.infoList.find((i) => i.label === "IP Address")
                  .value === "")) ||
            this.state.wifiReset ? (
              <div className="wifi-panel panel">
                {/* <img src="img/icon_arrow_back.svg" className="Icon-arrow_back"></img> */}
                <div className="WiFi-password-container">
                  <div className="wifi-setting-title">
                    <span className="WiFi-">WiFi 설정</span>
                    <img
                      alt="character2"
                      src="img/character2.svg"
                      className="character2"
                    ></img>
                  </div>
                  <div className="wifi-name-container">
                    <div>
                      <div>
                        <span className="wifi-checkbox-1">WiFi 직접 입력</span>
                        <input
                          type="checkbox"
                          checked={this.state.wifiDirectSSID}
                          onChange={() =>
                            this.setState({
                              wifiDirectSSID: !this.state.wifiDirectSSID,
                            })
                          }
                        />
                        <span className="wifi-checkbox-2">학교용 WiFi</span>
                        <input
                          type="checkbox"
                          checked={this.state.wifiEnt}
                          onChange={() =>
                            this.setState({
                              wifiEnt: !this.state.wifiEnt,
                            })
                          }
                        />
                      </div>
                      <span className="Wifi-Name">WiFi Name</span>
                      {!this.state.wifiDirectSSID ? (
                        this.state.infoList.find(
                          (i) => i.label === "WiFi list"
                        ) !== undefined &&
                        this.state.infoList.find((i) => i.label === "WiFi list")
                          .value !== "" ? (
                          <select
                            className="wifi-name-input"
                            onChange={(value) =>
                              this.setState({ ssid: value.target.value })
                            }
                          >
                            <option value="">
                              {"  "}와이파이 이름(SSID) 한글이름 연결불가
                            </option>
                            {this.state.infoList
                              .find((i) => i.label === "WiFi list")
                              .value.split("ESSID:")
                              .map((ssid, index) => {
                                if (index !== 0)
                                  return (
                                    <option
                                      key={index}
                                      value={ssid.split('"')[1]}
                                    >
                                      {ssid.split('"')[1]}
                                    </option>
                                  );
                                else return null;
                              })}
                          </select>
                        ) : (
                          <input
                            placeholder="  와이파이 검색중"
                            className="wifi-name-input"
                            disabled
                          />
                        )
                      ) : (
                        <input
                          className="wifi-name-input"
                          placeholder="  와이파이 이름(SSID) 한글이름 연결불가"
                          value={this.state.ssid}
                          onChange={(value) =>
                            this.setState({ ssid: value.target.value })
                          }
                        />
                      )}
                    </div>
                    {this.state.wifiEnt ? (
                      <div>
                        <span className="Wifi-Ent-ID">학교용 WiFi ID</span>
                        <input
                          className="wifi-Ent-ID-input"
                          placeholder="  와이파이 아이디"
                          value={this.state.entId}
                          onChange={(value) =>
                            this.setState({
                              entId: value.target.value.replace(
                                /[ㄱ-ㅎㅏ-ㅣ가-힣]/g,
                                ""
                              ),
                            })
                          }
                        />
                      </div>
                    ) : null}
                    <div>
                      <span className="Wifi-Password">WiFi Password</span>
                      <input
                        className="wifi-password-input"
                        placeholder="  와이파이 비밀번호"
                        value={this.state.password}
                        onChange={(value) =>
                          this.setState({
                            password: value.target.value.replace(
                              /[ㄱ-ㅎㅏ-ㅣ가-힣]/g,
                              ""
                            ),
                          })
                        }
                        type="password"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            this.inputWifi();
                          }
                        }}
                      />
                    </div>
                  </div>
                  {/* <div>
                    <input placeholder="Key (Default: pibox)" value={this.state.key} onChange={(value) => this.setState({ key: value.target.value })} />
                  </div> */}
                  <div>
                    <img
                      alt="wifi-button"
                      className="wifi-button"
                      onClick={this.inputWifi}
                      disabled={this.state.wifiLock}
                      src={
                        this.state.wifiLock
                          ? "img/wifing_button.svg"
                          : "img/wifi_button.svg"
                      }
                    ></img>
                  </div>
                </div>
              </div>
            ) : null}
            {this.state.isConnected &&
            this.state.infoList.find((i) => i.label === "IP Address") !==
              undefined &&
            this.state.infoList.find((i) => i.label === "IP Address").value !==
              "" &&
            !this.state.wifiConnected &&
            !this.state.wifiReset ? (
              <div className="connect-panel panel">
                <img
                  alt="Icon-arrow_back"
                  src="img/icon_arrow_back.svg"
                  onClick={() => this.setState({ wifiReset: true })}
                  className="Icon-arrow_back"
                ></img>
                <div className="character-button">
                  <img
                    alt="character2"
                    src="img/character2.svg"
                    className="character"
                  ></img>
                  <div className="Look-it-up">WiFi 설정이 완료 되었습니다.</div>
                  <div className="PLAi-Bluetooth-">
                    에이스플레이와 함께 놀아볼까요?
                  </div>
                  <div
                    onClick={() => {
                      this.setState({ wifiConnected: true });
                      console.log(
                        this.state.infoList.find(
                          (i) => i.label === "IP Address"
                        ).value
                      );
                    }}
                  >
                    <img
                      alt="wifi_next"
                      src="img/wifi_next.svg"
                      className="bluetooth_button"
                    ></img>
                  </div>
                </div>
              </div>
            ) : null}
            {/* <div className="command-panel panel">
              <div className="panel-title">커스텀 명령어</div>
              {this.state.commandList.length > 0 ? (
                <div>
                  <div>
                    {this.state.commandList.map((item) => (
                      <div key={item.uuid} className="button-wrap">
                        <button size="small" onClick={() => this.sendCommand(item.uuid)}>
                          {item.label}
                        </button>
                      </div>
                    ))}
                  </div>
                  <div>
                    <input placeholder="Key (Default: pibox)" value={this.state.key} onChange={(value) => this.setState({ key: value.target.value })} />
                  </div>
                  <div>
                    <input type="textarea" placeholder="Output" value={this.state.commandOutput} readOnly={true} rows="10" />
                  </div>
                </div>
              ) : (
                <p>커스텀 명령어가 없습니다.</p>
              )}
            </div> */}
          </div>
          {/* {this.state.isConnected && false ? (
            <div className="panel-container">
              <WifiSSH ipAddress={this.state.infoList.find((i) => i.label === "IP Address") === undefined ? "" : this.state.infoList.find((i) => i.label === "IP Address").value} />
            </div>
          ) : null} */}

          {this.state.isConnected &&
          !this.state.isBlockCoding &&
          this.state.wifiConnected &&
          !this.state.wifiReset ? (
            <div className="connect-panel panel">
              <img
                alt="Icon-arrow_back"
                src="img/icon_arrow_back.svg"
                onClick={() => this.setState({ wifiReset: true })}
                className="Icon-arrow_back"
              ></img>
              <div className="character-button">
                <img
                  alt="character"
                  src="img/plai_character.svg"
                  className="character"
                ></img>
                {this.state.isConnected &&
                this.state.infoList.find((i) => i.label === "IP Address") !==
                  undefined &&
                this.state.infoList.find((i) => i.label === "IP Address")
                  .value !== "" &&
                this.state.infoList.find((i) => i.label === "Machine ID") !==
                  undefined &&
                this.state.infoList.find((i) => i.label === "Machine ID")
                  .value !== "" &&
                !this.state.isBlockCoding &&
                this.state.wifiConnected ? (
                  <div>
                    <img
                      width="343"
                      height="56"
                      alt="bluetooth_button"
                      src="img/start_blockcode_button.svg"
                      className="bluetooth_button"
                      onClick={async () => {
                        this.setLoadingToTrue();
                        this.sendCommand(
                          this.state.commandList.find(
                            (c) => c.label === "camStart"
                          ).uuid
                        );
                        await this.wait(2.0);
                        await this.waitCamera();
                        this.setState({ isBlockCoding: true });
                      }}
                    ></img>
                  </div>
                ) : (
                  <div>
                    <img
                      width="343"
                      height="56"
                      alt="start_blockcode_button_not_available"
                      src="img/start_blockcode_button_not_available.svg"
                      className="bluetooth_button_no"
                    ></img>
                  </div>
                )}
                <div>
                  <img
                    width="343"
                    height="56"
                    alt="start_plai_button"
                    src="img/start_plai_button.svg"
                    className="bluetooth_button"
                    onClick={async () => {
                      this.sendCommand(
                        this.state.commandList.find((c) => c.label === "start")
                          .uuid
                      );
                      alert("실행 명령을 전달했습니다.");
                      await this.wait(0.5);
                    }}
                  ></img>
                </div>
                <div>
                  <img
                    width="343"
                    height="56"
                    alt="stop_plai_button"
                    src="img/stop_plai_button.svg"
                    className="bluetooth_button"
                    onClick={async () => {
                      this.sendCommand(
                        this.state.commandList.find((c) => c.label === "stop")
                          .uuid
                      );
                      alert("정지 명령을 전달했습니다.");
                      this.setState({ isBlockCoding: false });
                      await this.wait(0.5);
                    }}
                  ></img>
                </div>
                <div>
                  <img
                    width="343"
                    height="56"
                    alt="plai_reboot_button"
                    src="img/plai_reboot_button.svg"
                    className="bluetooth_button"
                    onClick={async () => {
                      this.sendCommand(
                        this.state.commandList.find((c) => c.label === "reboot")
                          .uuid
                      );
                      alert("재부팅 명령을 전달했습니다.");
                      await this.wait(0.5);
                      window.location.reload();
                    }}
                  ></img>
                </div>
              </div>
            </div>
          ) : null}
          {this.state.isConnected &&
          this.state.isBlockCoding &&
          this.state.wifiConnected &&
          !this.state.wifiReset ? (
            <div className="panel-container">
              <BlockCode
                ipAddress={
                  this.state.infoList.find((i) => i.label === "IP Address") ===
                  undefined
                    ? ""
                    : this.state.infoList.find((i) => i.label === "IP Address")
                        .value
                }
                machineId={
                  this.state.infoList.find((i) => i.label === "Machine ID") ===
                  undefined
                    ? ""
                    : this.state.infoList.find((i) => i.label === "Machine ID")
                        .value
                }
                sendCommand={this.sendCommand}
                uploadUUID={
                  this.state.commandList.find((c) => c.label === "upload").uuid
                }
                setIsBlockCoding={this.setIsBlockCodingToFalse}
                setLoadingToFalse={this.setLoadingToFalse}
                setLoadingToTrue={this.setLoadingToTrue}
              />
            </div>
          ) : null}

          {/* <div className="copyright">
            PiBox . Open source under GPL-3.0 license.
          </div> */}
        </div>
      </div>
    );
  }
}

// https://stackoverflow.com/questions/46946380/fetch-api-request-timeout
function fetchTimeout(url, options, timeout = 7000) {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("timeout")), timeout)
    ),
  ]);
}
